import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/harikaradmin/events")({
  component: AdminEventsLayout,
});

function AdminEventsLayout() {
  return <Outlet />;
}
